// extracted by mini-css-extract-plugin
module.exports = {"container":"savedSearchesCard_container__3AOW0","icon":"savedSearchesCard_icon__2Vhdh"};
    if(module.hot) {
      // 1790670309532
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  